import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbLogNotificacao } from 'app/abstract/full-pages/log-notificacao/log-notificacao.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogNotificacaoService extends AbLogNotificacao {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllLogs(filter: AppFilter): Observable<any> {
    return this.get(`admin/log_notificacao/filter/${filter.encode()}`);
  }

  public getNotificacao(id: number, tipo: string): Observable<any> {
    if (tipo == "DISPOSITIVO")
      return this.get("admin/log_notificacao/dto/dispositivo/", id);
    return this.get("admin/log_notificacao/dto/", id);
  }

  public getAllLogsDispositivo(filter: AppFilter): Observable<any> {
    return this.get(`admin/log_notificacao/filter/dispositivo/${filter.encode()}`);
  }
}